import { render } from "./SiteBanner.vue?vue&type=template&id=a2ef0e34"
import script from "./SiteBanner.vue?vue&type=script&lang=js"
export * from "./SiteBanner.vue?vue&type=script&lang=js"

import "./SiteBanner.vue?vue&type=style&index=0&id=a2ef0e34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__